export const DEV = process.env.NODE_ENV === 'development';

export const TEST = process.env.NODE_ENV === 'test';
